import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The browser keeps the old scroll offset on client-side navigation, so a menu click from the bottom of a page
// opened the next page at its bottom. Start every new page at the top, or at #anchor when the link has one.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
